import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { statusList, toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

const CollectionStatus = () => {
	const filterData = useSelector((store) => store.filterFieldStore);
	const dispatch = useDispatch();

	const getValue = (status) => {
		if (status.key === 'DEVELOPMENT') return 'TECHPACK,DEVELOPMENT,PRESENTATION';
		else if (status.key === 'COMPLETE_AND_PUBLISHED') return 'COMPLETE,PUBLISHED';
		else return '';
	};

	const handleCheckbox = (e, status) => {
		let { value, checked, name } = e.target;
		let data = {
			name: 'status',
			key: getValue(status),
			type: 'FILTER',
			value: value,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	const renderStatusList = () => {
		// if (processName === 'Collection') {
		// 	list = collectionStatusList;
		// }
		return statusList.map((status, index) => {
			return (
				<div className="form-group" key={`filter_status_${index}`}>
					<input
						type="checkbox"
						id={`initial_${index}`}
						name={`status_${index}`}
						value={status.value}
						onChange={(e) => handleCheckbox(e, status)}
						checked={toggleCheckbox(filterData, 'status', `status_${index}`)}
					/>
					<label htmlFor={`initial_${index}`}>
						<span>{status.value}</span>
					</label>
					{/* <div className={`color-box ${status.color}`} /> */}
				</div>
			);
		});
	};

	return (
		<div className="card initial">
			<div className="custom-chekbox">{renderStatusList()}</div>
		</div>
	);
};

export default CollectionStatus;
